export function toOffsetLimit(page: number, pageSize: number) {
  const safePage = Math.max(1, page);
  const safePageSize = Math.max(1, pageSize);

  return {
    offset: (safePage - 1) * safePageSize,
    limit: safePageSize,
  };
}
